<template>
  <section class="float-navigator">
    <div class="inner">
      <template v-if="!onlyHome">
        <mall-transition-expand>
          <ul class="menu" v-if="!collapse">

            <li class="menu-item" key="home" @click="goHome" v-cbs="`悬浮按钮-首页`">
              <div class="icon">
                <img src="~@cdn_img/nav-1.svg">
              </div>
              <div class="text">首页</div>
            </li>

            <li class="menu-item" key="order" @click="gotoUrl('/orders')" v-cbs="`悬浮按钮-订单`" v-if="isLogin">
              <div class="icon">
                <img src="~@cdn_img/nav-2.svg">
              </div>
              <div class="text">订单</div>
            </li>
            <li class="menu-item" key="order" @click="openApp('/orders')" v-cbs="`悬浮按钮-订单`" v-else>
              <div class="icon">
                <img src="~@cdn_img/nav-2.svg">
              </div>
              <div class="text">订单</div>
            </li>

            <li class="menu-item" key="coupon" @click="gotoUrl('/coupons')" v-cbs="`悬浮按钮-优惠券`" v-if="isLogin">
              <div class="icon">
                <img src="~@cdn_img/nav-3.svg">
              </div>
              <div class="text">优惠券</div>
            </li>
            <li class="menu-item" key="coupon" @click="openApp('/coupons')" v-cbs="`悬浮按钮-优惠券`" v-else>
              <div class="icon">
                <img src="~@cdn_img/nav-3.svg">
              </div>
              <div class="text">优惠券</div>
            </li>

            <!-- <li class="menu-item" key="service" v-if="isLogin">
              <a href="changba://?ac=userchat&chat_userid=28">
                <div class="icon">
                  <img src="~@cdn_img/nav-4.svg">
                </div>
                <div class="text">客服</div>
              </a>
            </li> -->

          </ul>
        </mall-transition-expand>

        <transition name="menu">
          <ul class="menu collapsed" @click="collapse = false" v-if="collapse">
            <li class="menu-item">
              <div class="icon">
                <img src="~@cdn_img/nav-0.svg">
              </div>
              <div class="text">订单</div>
            </li>
          </ul>
        </transition>
      </template>

      <template v-else>
        <ul class="menu collapsed">
          <li class="menu-item" @click="goHome" v-cbs="`悬浮按钮-首页`">
            <div class="icon">
              <img src="~@cdn_img/nav-1.svg">
            </div>
            <div class="text">首页</div>
          </li>
        </ul>
      </template>
    </div>
  </section>
</template>

<script>
import MallTransitionExpand from './TransitionExpand';
import localStorage from '../local-storage';
import addToken from '../libs/add-token';
import commonObj from 'commonObj';

export default {
  name: 'MallFloatNavigator',

  components: {
    MallTransitionExpand
  },

  props: {
    onlyHome: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      collapse: false,
      scrollCount: 0
    }
  },

  computed: {
    isLogin() {
      return this.$curuserid && this.$token;
    },

    isMusicboard() {
      return localStorage.getItem('changba-music-mall-float-navigator') === 'musicboard';
    }
  },

  activated() {
    this.collapse = false;
    this.scrollCount = 0;
  },

  mounted() {
    window.addEventListener('scroll', this.handleScroll);
  },

  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
  },

  methods: {
    handleScroll() {
      if (this.scrollCount < 3) {
        this.scrollCount++;
        return;
      }

      if (!this.collapse) {
        this.collapse = true;
      }
    },

    goHome() {
      if (this.$route.path === '/') {
        window.location.reload();
      }
      else {
        if (this.isLogin) {
          if (this.isMusicboard) {
            this.gotoMusicboard();
          }
          else {
            this.$router.push('/');
          }
        }
        else {
          this.openApp('/');
        }
      }
    },

    openApp(uri) {
      commonObj.utils.openApp(false, `${window.location.origin}${this.$router.options.base}${uri}`);
    },

    gotoUrl(url) {
      if (this.$route.path === '/') {
        if (url.indexOf('/') === 0) {
          url = `${window.location.origin}${this.$router.options.base}${url}`;
        }

        if (this.isMusicboardHome()) {
          url = this.setMusicboardUrlParam(url, 'yes');

          // 用于开发和调试
          if (/^https?:\/\/\S+\.changbaops\.com/.test(url)) {
            url = addToken(url);
          }

          url = `changba://?ac=webview&notfinish=yes&customurl=${encodeURIComponent(window.btoa(url))}`;
        }
        else {
          url = addToken(url);
          url = this.setMusicboardUrlParam(url, 'no');
        }

        window.location = url;
      }
      else {
        this.$router.push(url);
      }
    },

    setMusicboardUrlParam(url, value) {
      const parsedUrl = new URL(url);

      parsedUrl.searchParams.set('back_musicboard', value);

      return parsedUrl.href;
    },

    isMusicboardHome() {
      return this.$route.query.musicboard_home === 'yes';
    },

    gotoMusicboard() {
      window.location = 'changba://?ac=musicboard';
    }
  }
}
</script>

<style lang="scss" scoped>
.float-navigator {
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 100;
  font-size: 0;

  .inner {
    position: relative;
    max-width: 10rem;
    margin: 0 auto;
    margin-bottom: constant(safe-area-inset-bottom);
    margin-bottom: env(safe-area-inset-bottom);

    .menu {
      position: absolute;
      right: 15px;
      bottom: 20px;
      width: 50px;
      min-height: 66px;
      padding-top: 15px;
      padding-bottom: 13px;
      background: #fff;
      border: 0.5px solid #ddd;
      border-radius: 10000px;
      box-shadow: 0 4px 10px 0 rgba(0, 0, 0, 0.15);

      .menu-item {
        cursor: pointer;

        + .menu-item {
          position: relative;
          margin-top: 26px;

          &:before {
            position: absolute;
            top: -14px;
            left: 14px;
            width: 20px;
            height: 0.5px;
            background-color: #eee;
            content: "";
          }
        }

        a {
          display: block;
        }

        .icon {
          width: 18px;
          margin: 0 auto;

          img {
            width: 100%;
          }
        }

        .text {
          margin-top: 7px;
          color: #666;
          font-size: 11px;
          text-align: center;
        }
      }
    }

    .menu-enter-active,
    .menu-leave-active {
      transition: opacity .5s;
    }

    .menu-enter,
    .menu-leave-to {
      opacity: 0;
    }
  }
}
</style>
